const Footers = () => {
    return ( 
        <footer className=" downFooter bg-gray-900 text-white text-center py-6">
      <p>© 2025 Designersview. All rights reserved.</p>
      <div className="mt-2 space-x-4">
        <a href="/project" className="hover:text-indigo-400">Projects</a>
        <a href="/aboutMe" className="hover:text-indigo-400">About</a>
        <a href="/callMe" className="hover:text-indigo-400">Contact</a>
      </div>
    </footer>
     );
}
 
export default Footers;